import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Select, Input, Button, Table, message, DatePicker } from 'antd';
import moment from 'moment';
import { EditOutlined } from '@ant-design/icons';
import { SelectEmployee } from '../SelectInput';
import { updateRequest } from '../../utils/APICall';

const { Option } = Select;

const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
];

const UpdatePayslipForm = ({ visible, onCancel, onOk, editingData, monthnum }) => {
  const [entries, setEntries] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const { allEmployee } = useSelector((state) => state.employees);
  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) {
        return false;
      }
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee)
  // console.log("editingData", editingData)

  const predefinedTypes = [
    'Basic Salary', 'Bonus', 'Annual Bonus', 'Bonus Deduction', 'Deduction',
    'Extra Benifits', 'Gross Salary', 'Income Tax', 'Leave Encash', 'Loan',
    'Medical', 'Other Benifits', 'Special Bonus', 'Text Deduction',
    'Fuel Allownce', 'Advance Salary Deduction', 'Other'
  ];

  const [formData, setFormData] = useState({
    empName: '',
    chequeNo: '',
    month: '',
    year: new Date().getFullYear().toString(),
    type: '',
    earning: '',
    deduction: '',
    payslipId: ''
  });

  useEffect(() => {
    if (editingData) {
      setFormData({
        empName: editingData?.empid || '',
        chequeNo: editingData?.chequeno || '',
        month: monthnum || '',
        year: editingData?.year || new Date().getFullYear().toString(),
        type: '',
        earning: '',
        deduction: '',
        payslipId: ''
      });
      setEmployeeId(editingData?.empid || null);




      // --- Update entries from salaryHead ---
      if (Array.isArray(editingData.salaryHead)) {
        const formattedEntries = editingData.salaryHead.map(item => ({
          payslipId: item.payslipId,
          type: item.head,
          earning: item.earning,
          deduction: item.deduction
        }));
        // console.log("formattedEntries",formattedEntries)
        setEntries(formattedEntries);
      } else {
        setEntries([]);
      }
    }
  }, [editingData]);

  const resetForm = () => {
    setFormData({
      empName: '',
      chequeNo: '',
      month: '',
      year: new Date().getFullYear().toString(),
      type: '',
      earning: '',
      deduction: ''
    });
    setEntries([]);
    setEmployeeId(null);
    setEditingIndex(null);
  };

  const handleAddOrUpdate = () => {
    const { type, earning, deduction, payslipId } = formData;


    const newEntry = {
      payslipId,
      type,
      earning,
      deduction: deduction || '0',
    };

    if (editingIndex !== null) {
      const updatedEntries = [...entries];
      updatedEntries[editingIndex] = newEntry;
      // console.log("updatedEntries",updatedEntries)
      setEntries(updatedEntries);
      setEditingIndex(null);
    } else {
      setEntries([...entries, newEntry]);
    }

    setFormData({ ...formData, type: '', earning: '', deduction: '' });
  };

  const handleSubmit = async () => {
    const { chequeNo, month, year, } = formData;

    if (!employeeId || !chequeNo || !month || !year || entries.length === 0) {
      message.error('Please fill all required fields.');
      return;
    }
    // console.log("entries",entries)
    const payload = {
      vempName: employeeId,
      vchequeno: chequeNo,
      vmonthName: month,
      vyear: year,
      // vstatus: 0,
      entries: entries.map((entry) => ({
        vpayslipid: entry.payslipId,
        vtype: entry.type,
        vearning: entry.earning,
        vdeduction: entry.deduction,
      })),
    };

    // console.log("Sending payload:", payload);

    try {
      const res = await updateRequest('updatePayslips', payload);
      // console.log("response",res)
      if (res?.success) {
        message.success(res.message);
        resetForm();
        onOk();
      } else {
        throw new Error(res.error || 'Something went wrong');
      }
    } catch (error) {
      message.error(error.message);
    }
  };




  const columns = [
    { title: 'Type', dataIndex: 'type' },
    { title: 'Earning', dataIndex: 'earning' },
    { title: 'Deduction', dataIndex: 'deduction' },
    {
      title: 'Action',
      render: (_, __, index) => (
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => {
            const entry = entries[index];
            setFormData({
              ...formData,
              type: entry.type,
              earning: entry.earning,
              deduction: entry.deduction,
              payslipId: entry.payslipId
            });
            setEditingIndex(index);
          }}
        />
      )
    }
  ];

  return (
    <Modal
      title={
                <span className='flex justify-center text-xl font-bold'>
                    Update Payslip
                </span>
            }
      visible={visible}
      onCancel={() => {
        resetForm();
        onCancel();
      }}
      footer={null}
      width={1000}
    >
      <div className="flex flex-wrap gap-4 mb-4">
        <div className="flex flex-col w-full sm:w-[180px]">
          <label className="mb-1 font-semibold">
            Employee Name <span className="text-red-500">*</span>
          </label>
          <SelectEmployee
            employeeList={filterData}
            onChange={(value) => setEmployeeId(value)}
            selectedEmployee={employeeId}
            customStyle="w-full"
            allLabel={{}}
          />
        </div>

        <div className="flex flex-col w-full sm:w-[180px]">
          <label className="mb-1 font-semibold">
            Cheque No <span className="text-red-500">*</span>
          </label>
          <Input
            placeholder="Enter cheque number"
            value={formData.chequeNo}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              setFormData({ ...formData, chequeNo: value });
            }}
          />
        </div>

        <div className="flex flex-col w-full sm:w-[180px]">
          <label className="mb-1 font-semibold">
            Month <span className="text-red-500">*</span>
          </label>
          <Select
            placeholder="Select month"
            value={formData.month}
            onChange={(val) => setFormData({ ...formData, month: val })}
          >
            {months.map((m) => (
              <Option key={m.value} value={m.value}>
                {m.label}
              </Option>
            ))}
          </Select>
        </div>

        <div className="flex flex-col w-full sm:w-[180px]">
          <label className="mb-1 font-semibold">
            Year <span className="text-red-500">*</span>
          </label>
          <DatePicker
            picker="year"
            className="w-full h-10"
            placeholder="Select year"
            value={formData.year ? moment(formData.year, 'YYYY') : null}
            onChange={(date, dateString) =>
              setFormData({ ...formData, year: dateString })
            }
          />
        </div>
      </div>

      <div className="border p-4 mb-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-end">
        <div className="flex flex-col">
          <label className="mb-1 font-semibold">Type</label>
          <Select
            mode="combobox"
            showSearch
            placeholder="Select or type type"
            value={formData.type}
            onChange={(val) => setFormData({ ...formData, type: val })}
            className="w-full"
          >
            {predefinedTypes.map((t) => (
              <Option key={t} value={t}>
                {t}
              </Option>
            ))}
          </Select>
        </div>

        <div className="flex flex-col">
          <label className="mb-1 font-semibold">Earning</label>
          <Input
            placeholder="Enter earning"
            value={formData.earning}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              setFormData({ ...formData, earning: value });
            }}
          />
        </div>

        <div className="flex flex-col">
          <label className="mb-1 font-semibold">Deduction</label>
          <Input
            placeholder="Enter deduction"
            value={formData.deduction}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              setFormData({ ...formData, deduction: value });
            }}
          />
        </div>

        <div>
          <Button
            type="primary"
            className="w-full bg-green-500"
            onClick={handleAddOrUpdate}
          >
            {editingIndex !== null ? 'Update' : 'Add'}
          </Button>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={entries}
        pagination={false}
        rowKey={(_, index) => index}
      />

      <div className="flex justify-end gap-2 mt-4">
        <Button className="bg-gray-300 hover:bg-gray-400" onClick={resetForm}>
          New
        </Button>
        <Button
          className="bg-green-500 text-white hover:bg-green-600"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default UpdatePayslipForm;
